import TextureHeading from './TextureHeading'
export default TextureHeading
